import { render } from "./LitePractice.vue?vue&type=template&id=d9946d8e"
import script from "./LitePractice.vue?vue&type=script&lang=js"
export * from "./LitePractice.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__